import React from 'react';
import { ChevronRight } from 'lucide-react';

export default function PageHeader({ title, description, actions, breadcrumbs }) {
  return (
    <div className="mb-7">
      {breadcrumbs && (
        <nav className="text-[12px] text-slate-500 mb-2.5 flex items-center gap-1.5">
          {breadcrumbs.map((b, i) => (
            <React.Fragment key={i}>
              {i > 0 && <ChevronRight className="h-3 w-3 text-slate-300" strokeWidth={2} />}
              <span className={i === breadcrumbs.length - 1 ? 'text-slate-800 font-medium' : 'hover:text-slate-700 cursor-default'}>{b}</span>
            </React.Fragment>
          ))}
        </nav>
      )}
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-[26px] md:text-[28px] font-semibold text-slate-900 tracking-[-0.028em] leading-[1.15] text-balance">{title}</h1>
          {description && <p className="text-slate-500 mt-1.5 text-[14px] leading-relaxed max-w-2xl text-pretty">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </div>
  );
}
